/**
 * cs-promo-scroll.js
 * Desktop: Prev / Next arrows (shown/hidden based on scroll position)
 * Mobile: pure CSS touch scroll — this script does nothing on touch devices.
 */
(function () {
  'use strict';

  document.querySelectorAll('.cs-pscroll').forEach(function (section) {
    var scroll  = section.querySelector('[data-cs-ps-scroll]');
    var btnPrev = section.querySelector('.cs-pscroll__arrow--prev');
    var btnNext = section.querySelector('.cs-pscroll__arrow--next');

    if (!scroll) return;

    /* ── Arrow visibility ── */
    function updateArrows() {
      if (!btnPrev || !btnNext) return;

      var atStart = scroll.scrollLeft <= 4;
      var atEnd   = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 4;

      btnPrev.style.display = 'flex';
      btnNext.style.display = 'flex';

      btnPrev.classList.toggle('cs-pscroll__arrow--hidden', atStart);
      btnNext.classList.toggle('cs-pscroll__arrow--hidden', atEnd);
    }

    /* ── Scroll by one card width ── */
    function scrollByCard(direction) {
      var card = scroll.querySelector('.cs-pscroll__card');
      var gap  = parseInt(getComputedStyle(scroll).gap, 10) || 24;
      var step = card ? card.offsetWidth + gap : 240;
      scroll.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (btnPrev) {
      btnPrev.removeAttribute('hidden');
      btnPrev.addEventListener('click', function () { scrollByCard(-1); });
    }
    if (btnNext) {
      btnNext.removeAttribute('hidden');
      btnNext.addEventListener('click', function () { scrollByCard(1); });
    }

    scroll.addEventListener('scroll', updateArrows, { passive: true });
    requestAnimationFrame(updateArrows);
  });

})();
